import { render } from "./Basics.vue?vue&type=template&id=bcc6aa90&scoped=true"
import script from "./Basics.vue?vue&type=script&lang=js"
export * from "./Basics.vue?vue&type=script&lang=js"

import "./Basics.vue?vue&type=style&index=0&id=bcc6aa90&lang=scss&scoped=true"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcc6aa90"]])

export default __exports__